import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, trend }) => {
  const getTrendColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const isPercentChange = typeof change === 'string' && change.includes('%');

  return (
    <div className="bg-card rounded-lg border border-border p-4 card-shadow flex flex-col h-full min-h-[148px]">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 shrink-0 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
        <p className="text-sm font-medium text-muted-foreground leading-snug min-w-0 flex-1">
          {title}
        </p>
      </div>

      <p className="text-2xl font-bold text-foreground mt-3 mb-auto tabular-nums">{value}</p>

      {(change || trend) && (
        <div className="mt-4 pt-3 border-t border-border space-y-1">
          {change && (
            <div className={`flex items-center gap-1.5 text-xs font-medium ${getTrendColor()}`}>
              {isPercentChange && (
                <Icon name={getTrendIcon()} size={14} className="shrink-0" />
              )}
              <span className="leading-snug break-words">{change}</span>
            </div>
          )}
          {trend && (
            <p className="text-xs text-muted-foreground leading-snug break-words">{trend}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default MetricsCard;
